<template>
    <h1>
        Logging Out......
    </h1>
</template>

<script>
import axios from 'axios'
import {clearExpandedNodesFromStorage} from "@/common/functions";

export default {
        name: 'Logout',
        created: function () {

            this.handleLogout()
        },
        methods: {
            handleLogout: function () {
                console.log('std logout')
                axios.post('/auth/session').then( () => {
                    console.log('Asking to Logout')
                  this.deleteSession()
                  clearExpandedNodesFromStorage();
                  sessionStorage.setItem('returnUrl', '/');
                }, error => {
                  this.deleteSession()
                    console.log('Error in updating logout session', error)
                  sessionStorage.setItem('returnUrl', '/');
                })
            },
          deleteSession() {
            this.$store.commit('loggedOut')
            this.$router.push('/login')
            window.location.reload()
          }
        }
    }
</script>

<style scoped>

</style>
